export default "__VITE_ASSET__CWlTdhvb__"